import React, { MouseEventHandler, useEffect, useState } from 'react'
import Navigation from '../partials/Navigation'
import useOrderList from '../hooks/useOrderList'
import { OrderSummaryList } from '../components/OrderSummaryList'
import Page from '../components/Page'
import { Order, Transfer } from '../types'
import NavigationArrow from '../components/NavigationArrow'
import ListGroup from '../components/ListGroup'
import { TransferSummaryListItem } from '../components/TransferSummaryList'
import { useHistory } from 'react-router-dom'
import { PageURLs } from '../common'
import Drawer from '../components/Drawer'
import pluralize from 'pluralize'

const Billing: React.FC = () => {
  const history = useHistory()
  const [selected, setSelected] = useState<Order | undefined>()
  const api = useOrderList()
  const totalOrders = api.response.orders.length

  useEffect(() => {
    if (api.isLoading || selected !== undefined) {
      return
    }

    const urlParams = new URLSearchParams(window.location.search)
    const idx = api.response.orders.findIndex((x: Order) => x.id.toString() === urlParams.get('order_id'))

    if (idx > -1) {
      setSelected(api.response.orders[idx === -1 ? 0 : idx])
    }
  }, [api.isLoading])

  const closeDrawer = () => {
    setSelected(undefined)
  }

  const handleSelectOrder = (order: Order) => {
    setSelected(order)
  }

  const handleSelectTransfer = (transfer: Transfer) => {
    history.push(`${PageURLs.Transfers}?booking_id=${transfer.booking_id}`)
  }

  return (
    <Page className="bg-white">
      <Navigation />

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10 pt-4 pt-lg-5">
            <h2>Billing</h2>
            {/*<Tabs className="mt-4" selected={tab} tabs={{ orders: 'Payments', cards: 'Cards' }} onSelect={setTab} />*/}

            <div className="my-4">
              {api.isLoading ? (
                <p>Loading your payments</p>
              ) : (
                <>
                  <p>
                    You have <strong>{totalOrders}</strong> {pluralize('order', totalOrders)}.
                  </p>
                  <OrderSummaryList onSelect={handleSelectOrder} orders={api.response.orders} />
                  <Drawer visible={!!selected} onBackgroundClick={closeDrawer}>
                    {selected !== undefined && (
                      <div className="order-detail__wrapper">
                        <div className="container">
                          <NavigationArrow onClick={closeDrawer} compact />

                          <h5>Receipt</h5>
                          <h1>#{selected.id}</h1>

                          <div className="mb-4">
                            <a
                              className="btn btn-primary"
                              target="_blank"
                              href={`/wp-json/ac/v1/invoices/${selected.id}`}
                              rel="noreferrer"
                            >
                              Download
                            </a>
                          </div>

                          <ListGroup.Items>
                            {selected.transfers.map((item: Transfer, idx: number) => (
                              <ListGroup.Item hover key={idx}>
                                <TransferSummaryListItem
                                  icon
                                  showContactInformation
                                  showTags={false}
                                  transfer={item}
                                  key={idx}
                                  onSelect={handleSelectTransfer}
                                />
                              </ListGroup.Item>
                            ))}
                          </ListGroup.Items>
                        </div>
                      </div>
                    )}
                  </Drawer>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Page>
  )
}

export default Billing
